import { gql } from "@apollo/client";

export const CREATE_EXAM_PAPER = gql`
  mutation createExamPaper($input: CreateExamPaperInput!) {
    createExamPaper(input: $input) {
      updatedByName
      updatedById
      totalSections
      updatedAt
      totalQuestions
      totalMarks
      scheduledDate
      title
      questionTypes
      questionPaperPublicPdfUrl
      isAutomarksEnabled
      isAutogradeEnabled
      isArchived
      id
      createdByName
      createdById
      createdAt
      bloomsTaxonomyTwo
      bloomsTaxonomyOne
    }
  }
`;

export const UPDATE_EXAM_PAPER = gql`
  mutation updateExamPaper($input: UpdateExamPaperInput!) {
    updateExamPaper(input: $input) {
      id
      title
      questionPaperPublicPdfUrl
      scheduledDate
      totalSections
      totalMarks
      totalQuestions
      questionTypes
      bloomsTaxonomyOne
      bloomsTaxonomyTwo
      isArchived
      isAutogradeEnabled
      isAutomarksEnabled
      createdById
      createdByName
      updatedById
      updatedByName
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_EXAM_PAPER_ANSWER_KEY = gql`
  mutation createExamPaperAnswerKey($input: CreateExamPaperAnswerKeyInput!) {
    createExamPaperAnswerKey(input: $input) {
      id
      examPaperId
      answerKeyPublicPdfUrl
      isArchived
      createdById
      updatedById
      createdAt
      updatedAt
      createdByName
      updatedByName
    }
  }
`;

export const UPDATE_EXAM_PAPER_ANSWER_KEY = gql`
  mutation updateExamPaperAnswerKey($input: UpdateExamPaperAnswerKeyInput!) {
    updateExamPaperAnswerKey(input: $input) {
      id
      examPaperId
      answerKeyPublicPdfUrl
      isArchived
      createdById
      createdByName
      updatedById
      updatedByName
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_EXAM_PAPER_DELIVERY = gql`
  mutation createExamPaperDelivery($input: CreateExamPaperDeliveryInput!) {
    createExamPaperDelivery(input: $input) {
      academicYearIds
      academicYearNames
      batchIds
      batchNames
      boardIds
      boardNames
      classIds
      classNames
      collegeIds
      collegeNames
      createdAt
      createdById
      createdByName
      deliveryExecutionCount
      examPaperId
      id
      isArchieved
      sortOrder
      source
      updatedAt
      updatedById
      updatedByName
    }
  }
`;

export const UPDATE_EXAM_PAPER_DELIVERY_EXICUTION = gql`
  mutation updateExamPaperDeliveryExecution(
    $input: UpdateExamPaperDeliveryExicutionInput!
  ) {
    updateExamPaperDeliveryExecution(input: $input) {
      id
      examPaperDeliveryId
      studentObjectId
      studentName
      collegeObjectId
      collegeName
      classObjectId
      className
      batchObjectId
      batchName
      boardObjectId
      boardName
      acadamicObjectId
      acadamicYearName
      isArchieved
      createdById
      createdByName
      updatedById
      updatedByName
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_EXAM_PAPER_QUESTIONS = gql`
  mutation createExamPaperQuestions($input: [CreateExamPaperQuestionInput!]!) {
    createExamPaperQuestions(input: $input) {
      id
      examPaperId
      sectionTitle
      sectionOrder
      questionNumber
      questionType
      marks
      questionSortOrder
      isArchived
      subjectId
      subjectName
      chapterId
      chapterName
      topicId
      topicName
      createdById
      createdByName
      updatedById
      updatedByName
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_EXAM_PAPER_QUESTIONS = gql`
  mutation updateExamPaperQuestions($input: [UpdateExamPaperQuestionInput!]!) {
    updateExamPaperQuestions(input: $input) {
      chapterId
      chapterName
      choiceCount
      createdAt
      createdById
      createdByName
      examPaperId
      id
      isArchived
      marks
      nodeType
      questionNumber
      questionSortOrder
      updatedByName
      updatedById
      updatedAt
      topicName
      subjectId
      subjectName
      topicId
      sectionTitle
      sectionOrder
      questionType
    }
  }
`;
